import PropTypes from 'prop-types'
/* eslint no-unused-vars: 0 */
/* eslint react/prefer-stateless-function: 0 */

import React, { Component } from 'react'
import HomeHeader from './HomeHeader'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import CreateActivityStory from './feed/CreateActivityStory'
import FeedStories from './feed/FeedStories'
import HomeSidebar from './HomeSidebar'

const mapStateToProps = (state) => ({
})

const mapDispatchToActions = {
}

export class ActivityFeed extends Component {
  static propTypes = {
  }

  render () {
    return (
      <div>
        <HomeHeader />
        <Row>
          <Col sm={8} xs={12}>
            <CreateActivityStory />
            <FeedStories />
          </Col>
          <Col sm={4} xs={12}>
            <HomeSidebar />
          </Col>
        </Row>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(ActivityFeed)
